// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState } from 'vuex';
import loading from '../../../../share/components/vue/ProcessingIcon';
import logWrapper from '../../../../share/logWrapper';
import error from '../../../../common/nodejs/errors';
import constants from '../../../../common/nodejs/constants';
import eventLogUtil from '../../../../share/util/eventLogUtil';
import util from '../../../../share/util/utils';

export default {

  data() {
    return {
      modelUpdateProcessing: true,
      turnIgOnChecked: false,
      constants: constants,
      // ダイアログ
      modal_platform_gen_decision: false,
      modal_mac_key_update_progress: false,
      modal_check_ignition_is_on: false,
      modal_uploading_downloading_in_progress: false,
      modal_check_ignition_is_off: false,
      modal_key_update_completed: false,
      modal_key_update_err_failed: false,
    };
  },

  props: {
    macUpdateEvent: Function,
    macUpdateInfo: Object,
    onSetEndOfProcessingFlag: Function,
    currentDialogId: String,
    modalShowInfo: {
      type: Object,
      require: false,
      default: () => ({ id: "", isShow: false, nextDialog: "" }),
    },
  },

  components: {
    'processing-view': loading,
  },

  computed: {
    ...mapState({
      vehicle: state => state.vehicle,
      netAppId: state => state.netAppConnector.pairingAppId
    }),

    // 診断通信エラー有無の判定
    isDiagCommError() {
      return this.macUpdateInfo.error_code === error.DIAG_COMM_ERROR_CODE;
    },

    // ECU異常処理エラー有無の判定
    isEcuError() {
      return this.macUpdateInfo.error_code === error.FAILED_ERROR_CODE || this.macUpdateInfo.error_code === error.MAC_KEY_FAILED_TO_UPDATE;
    },

    // プラットフォーム世代が19ePFか否かの判定
    isPlatformGen19epf() {
      return this.macUpdateInfo.platform_gen === constants.MAC_KEY_PLATFORM_GEN_19EPF;
    },

    // 鍵更新完了時のダイアログの文言を決定
    genMacKeyUpdateCompletedText() {
      const suffix = this.isPlatformGen19epf ? "" : "_continue_register_key";
      return this.$t(`mac.mac_key_update_completed${suffix}`);
    },

    // 鍵更新完了時のダイアログの注釈を決定
    genMacKeyUpdateCompletedAnnotation() {
      const suffix = this.isPlatformGen19epf ? "_19epf" : "";
      return this.$t(`mac.mac_key_update_completed_perform_memory_clear_all_units${suffix}`);
    }
  },

  watch: {
    modalShowInfo: {
      handler(value) {
        if (value) {
          const id = value.id.replace(/-/g, "_");
          if (util.hasPropertyCheck(this, id)) {
            this[id] = value.isShow;
            if (value.nextDialog) {
              const nextId = value.nextDialog.replace(/-/g, "_");
              if (util.hasPropertyCheck(this, nextId)) {
                this[nextId] = true;
              }
            }
          }
        }
      },
      deep: true,
    },
  },

  methods: {
    /**
     * 鍵更新のIG-ON/OFF指示画面でボタンを押下した際の処理
     * @param {String} action ボタンの種類
     */
    macUpdateEventOnIgnition: function (exeType) {
      this.macUpdateEvent(exeType);
      this.turnIgOnChecked = false;
      if ([2, 4].includes(exeType)) {
        eventLogUtil.updateMacEventLog(this.netAppId);
        this.determineEndOfProcessingFlag();
      }
    },

    /**
     * 鍵更新完了/エラー画面でOKボタンを押下した際の処理
     * @param {String} error_code エラーコード
     */
    onMacUpdateOkButtonClick: function () {
      const id = this.currentDialogId.replace(/-/g, "_");
      if (util.hasPropertyCheck(this, id)) {
        this[id] = false;
      }
      this.turnIgOnChecked = false;
      this.determineEndOfProcessingFlag();
    },

    /**
     * 処理完了フラグを設定する
     */
    determineEndOfProcessingFlag: function () {
      if (this.vehicle.vehicleInfo === null) {
        logWrapper.log('vehicle information is ', this.vehicle.vehicleInfo);
        this.onSetEndOfProcessingFlag();
      }
    },
  },

  created() { },

};